export class RetornoSelecao {
    novoCadastro: Boolean;
    registro: any;
}
